import styled from "styled-components";
import { generic } from "../../../../../ui/_themes/constants";

export const Dialog = styled.div`
  min-width: 65%;
  max-width: 90%;
  max-height: 90%;
  background: ${generic.dialogs.backgroundColor};
  border-radius: 4px;
  overflow: hidden;
  user-select: none;
  cursor: default;
  display: flex;
  flex-direction: column;
  padding: 1.4em;

  @media (min-width: 920px) {
    min-width: 50%;
  }
`;
